const readOutLoudButton = "_35sr5n571a";

export { readOutLoudButton };
import "./_speech-synthesis.style.linaria.module.css";
//# sourceMappingURL=_speech-synthesis.style.js.map
